import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingComponent from "../components/landing/LandingComponent";
import TermsConditionsComponent from "../components/terms-and-conditions/TermsConditionsComponent";
import PrivacyPolicyComponent from "../components/privacy-and-policy/PrivacyPolicyComponent";
import CancellationRefundPolicyComponent from "../components/cancellation-and-refund-policy/CancellationRefundPolicyComponent";
import PricingPolicy from "../components/pricing/pricingPolicyComponent";
import AccountDeletionPolicy from "../components/account-deletion-policy/accountDeletationComponent";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingComponent />} />
      <Route path="/terms-conditions" element={<TermsConditionsComponent />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyComponent />} />
      <Route path="/pricing-policy" element={<PricingPolicy />} />
      <Route
        path="/account-deletion-policy"
        element={<AccountDeletionPolicy />}
      />
      <Route
        path="/cancellation-and-refund-policy"
        element={<CancellationRefundPolicyComponent />}
      />
    </Routes>
  );
};

export default AppRoutes;
